import React from 'react';
import '../ForgotPassword/forgotPassword.scss';
import '../ResetPassword/resetPassword.scss';
import PwdReset from '../../assets/images/pwd-reset-icon.svg';
import { Link } from 'react-router-dom';

function SignUpSuccess() {
    return (
        <div className='forgot-password reset-password email-verified'>
            <div className="confirmation-div" style={{maxWidth: '450px'}}>
                <img src={PwdReset} alt="icon" />
                <h2>Signed Up Successfully</h2>
                <p style={{maxWidth: '400px'}}>You have signed up successfully. An email has been sent to you for verification. Please verify your email to log in.</p>
                <Link className='solid-button' to='/'>Login</Link>
            </div>
        </div>
    )
}

export default SignUpSuccess
